import React from 'react';
import { useNavigate, matchPath, useLocation } from 'react-router-dom';
import classnames from 'classnames';

import TrophyLeft from './trophy-left.svg';
import TrophyRight from './trophy-right.png';
import './style.scss';

const WorldCupTab = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = !!matchPath({ path: '/worldcup', end: false }, location.pathname);

  return (
    <div
      className={classnames('world-cup-tab', { active: isActive })}
      onClick={() => navigate('/worldcup')}
    >
      <div className="world-cup-tab-badge">
        <div className="world-cup-tab-gradient-bg" />
        <img
          src={TrophyLeft}
          alt=""
          className="world-cup-tab-trophy-left"
        />
        <div className="world-cup-tab-text">
          <span className="world-cup-tab-year">2026</span>
          <span className="world-cup-tab-title">FIFA World Cup</span>
        </div>
      </div>
      <img
        src={TrophyRight}
        alt=""
        className="world-cup-tab-trophy-right"
      />
    </div>
  );
};

export default WorldCupTab;
